import { virtualClient } from '../../request/index';
import BaseServer from '../common/base.server';
import useRoomBaseServer from '../room/roombase.server';
import useMsgServer from '@/domain/common/msg.server.js';

class VirtualClientStartServer extends BaseServer {
  constructor() {
    super();
    // this.virtualInstance = null; // 互动实例
    this.state = {
      person: {
        pv: '',
        basePv: '',
        baseTime: '',
        onlineNum: '',
        baseOnlineNum: ''
      },
      uvOnline: 1, // 真实人数
      virtualOnline: 0,
      uvHot: 0, // 真实热度
      virtualHot: 0,
      virtual_type: 2, // 虚拟人数设置类型 1:立即生效 2:分时生效 5:固定值
      addCount: ''
    };
    this.listenEvent();
    VirtualClientStartServer.instance = this;
    return this;
  }
  virtualClientStart(data = {}) {
    return virtualClient.virtualClientSet(data);
  }
  virtualClientStop(data = {}) {
    return virtualClient.virtualClientStop(data);
  }
  getVirtualSettings(data = {}) {
    return virtualClient.getVirtualSettings(data);
  }
  virtualAccumulation(data = {}) {
    return virtualClient.virtualAccumulation(data);
  }
  virtualClientGet(data = {}) {
    return virtualClient.virtualClientGet(data).then(res => {
      this.state.person.pv = res.data.pv;
      this.state.person.basePv = res.data.base_pv;
      this.state.person.baseTime = res.data.base_time;
      this.state.addCount = res.data.base_time;
      this.state.person.onlineNum = res.data.online;
      this.state.person.baseOnlineNum = res.data.base_online;
      return res;
    });
  }
  init() {
    const { online, pv } = useRoomBaseServer().state.watchInitData;
    this.state.virtualOnline = online?.virtual_type == 5 ? online?.fixed : online?.num || online?.virtual || 0;

    this.state.virtualHot = online?.virtual_type == 5 ? pv?.fixed : pv.num || pv.virtual || 0;
    this.state.uvHot = pv?.num2 || pv?.real || 0;
  }
  listenEvent() {
    const msgServer = useMsgServer();
    let isSendClient = Boolean(['send', 'record', 'clientEmbed'].includes(useRoomBaseServer().state.clientType))
    if (isSendClient) return;
    // 加入房间
    msgServer.$onMsg('JOIN', msg => {
      this.state.uvOnline = msg.uv;
      if (msg.context.pv > this.state.uvHot) {
        this.state.uvHot = msg.context.pv;
      }
    });
    // 离开房间 ROOM_NUM_UPDATE
    msgServer.$onMsg('LEFT', msg => {
      this.state.uvOnline = msg.uv;
    });
    // 添加虚拟人数和热度
    msgServer.$onMsg('ROOM_MSG', msg => {
      let msgs = msg.data;
      if (msgs.type == 'base_num_update') {
        this.state.virtualHot = this.state.virtualHot + Number(msgs.update_pv);
        this.state.virtualOnline = this.state.virtualOnline + Number(msgs.update_online_num);
      } else if (msgs.type == 'main_room_join_change') {
        // 分组直播，小组中和主房间切换，需要维护在线人数
        this.state.uvOnline = msg.uv;
      } else if (msgs.type == "virtual_type_change") {
        this.state.virtual_type = msgs.virtual_type;
        if (msgs.online_info.virtual_type == 5) {
          this.state.virtualOnline = msgs.online_info.fixed;
        }
        if (msgs.pv_info.virtual_type == 5) {
          this.state.virtualHot = msgs.pv_info.fixed;
        }

      }

    });
  }
  getVirtualLikesSet(params = {}) {
    const watchInitData = useRoomBaseServer().state.watchInitData
    params.room_id = watchInitData.interact.room_id
    params.webinar_id = watchInitData.webinar.id
    return virtualClient.getVirtualLikesSet(params)
  }
  getVirtualLikes(params = {}) {
    const watchInitData = useRoomBaseServer().state.watchInitData
    params.room_id = watchInitData.interact.room_id
    params.webinar_id = watchInitData.webinar.id
    return virtualClient.getVirtualLikes(params)
  }
  setVirtualLikes(params = {}) {
    const watchInitData = useRoomBaseServer().state.watchInitData
    params.room_id = watchInitData.interact.room_id
    params.webinar_id = watchInitData.webinar.id
    return virtualClient.setVirtualLikes(params)
  }
}
export default function useVirtualAudienceServer() {
  if (typeof VirtualClientStartServer.instance === 'object') {
    return VirtualClientStartServer.instance;
  }
  return new VirtualClientStartServer();
}
